import type { HTMLAttributes, PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import type { CurrencyPrimitive } from "@/api/cashier";
import { useFormatAmount } from "@/hooks/useFormatAmount";
import styles from "./DepositBankNotice.module.css";
import { classNames } from "@repo/ui";

type DepositBankNoticeProps = {
  fee: number;
  currency: CurrencyPrimitive;
} & PropsWithChildren &
  HTMLAttributes<HTMLDivElement>;

export const DepositBankNotice = ({
  children,
  fee,
  currency,
  ...props
}: DepositBankNoticeProps) => {
  const { t } = useTranslation();
  const { formatAmount } = useFormatAmount();
  return (
    <div {...props} className={classNames([styles.container, props.className])}>
      {children
        ? children
        : t("deposit.bank_notice", { fee: formatAmount(fee, currency) })}
    </div>
  );
};
